import loadable from '@loadable/component';

export const CmsShowAllReactionsModalContainerLoadable = loadable(
  () => import('./CmsShowAllReactionsModalContainer'),
  { resolveComponent: (module) => module.CmsShowAllReactionsModalContainer },
);
